import { cn } from "@newxsystems/shared";
import { RavioliCardLink } from "../RavioliCardLink/RavioliCardLink";
import { RavioliMedia } from "../RavioliMedia/RavioliMedia";
import { RavioliRichText } from "../RavioliRichText/RavioliRichText";
import type { IImageContentGridTopProps } from "./ImageContentGridTop.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const ImageContentGridTop = ({
  columnCount,
  headingAs = "h3",
  imageAspectRatio,
  items,
}: IImageContentGridTopProps) => {
  const Heading = headingAs;
  const effectiveColumnCount = Math.min(columnCount || 3, items.length) as 1 | 2 | 3 | 4;
  return (
    <div className={cn("grid gap-4", columns[effectiveColumnCount])}>
      {items.map((item, index) => (
        <RavioliCardLink
          className={cn("border-primary p-2", index % 2 === 0 ? "bg-collection" : "bg-surface")}
          key={index}
          link={item.cardLink}
        >
          <RavioliMedia
            aspectRatio={imageAspectRatio || "16:9"}
            imageClassName="transition-transform duration-200 ease-out group-hover:scale-[1.025]"
            media={item.image.image}
            sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
          />
          <div className="px-3 pb-3 pt-5">
            <Heading className="font-ravioli-display text-3xl font-semibold leading-[1.05] transition-colors group-hover:text-primary">
              {item.heading}
            </Heading>
            {item.description ? (
              <RavioliRichText
                className="mt-3 text-base text-ink-muted md:text-lg"
                content={item.description}
              />
            ) : null}
          </div>
        </RavioliCardLink>
      ))}
    </div>
  );
};

ImageContentGridTop.displayName = "Content::ImageContentGridTop";
